/* @flow */

import { blueGrey, evenLighterGrey } from '@e180/ui/lib/token/palette';
import avatarSizes from 'src/shared/ui/component/image/setting/avatarSizes';

let styles = {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: '100%',
    height: '100%',

    backgroundColor: evenLighterGrey,
    borderRadius: '50%',
    color: blueGrey,

    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1,
    textTransform: 'uppercase',
  },
};

for (const [key, size] of Object.entries(avatarSizes)) {
  styles = {
    ...styles,
    [`root-${key}`]: {
      width: size,
      height: size,

      fontSize: Number(size) * 0.3,
    },
  };
}

export default styles;
